import { isNullOrUndefined, isObjectLike } from '@modules/types';
import type { DBUser, DBUserTags } from 'types/db';

export function isDBUser(candidate: unknown): candidate is DBUser {
  return (
    isObjectLike(candidate) &&
    typeof candidate.user_id === 'string' &&
    (candidate.first_name === undefined || typeof candidate.first_name === 'string') &&
    (candidate.last_name === undefined || typeof candidate.last_name === 'string') &&
    (candidate.creation_timestamp_ms === undefined || typeof candidate.creation_timestamp_ms === 'number') &&
    (candidate.bb_org_id === undefined || typeof candidate.bb_org_id === 'string') &&
    (isNullOrUndefined(candidate.current_card_id) || typeof candidate.current_card_id === 'string') &&
    (candidate.avatar_url === undefined || typeof candidate.avatar_url === 'string') &&
    (candidate.card_ids === undefined || Array.isArray(candidate.card_ids)) &&
    (candidate.org_ids === undefined || Array.isArray(candidate.org_ids)) &&
    (candidate.is_anonymous === undefined || typeof candidate.is_anonymous === 'boolean') &&
    (candidate.country === undefined || typeof candidate.country === 'string') &&
    (candidate.company_size === undefined || typeof candidate.company_size === 'string') &&
    (candidate.sign_in_email_address === undefined || typeof candidate.sign_in_email_address === 'string') &&
    (candidate.is_ios_device === undefined || typeof candidate.is_ios_device === 'boolean')
  );
}

export function isDBUserTags(candidate: unknown): candidate is DBUserTags {
  return (
    isObjectLike(candidate) &&
    (isNullOrUndefined(candidate.can_add_custom_color) ||
      typeof candidate.can_add_custom_color === 'boolean') &&
    (isNullOrUndefined(candidate.can_add_logo_in_qr) || typeof candidate.can_add_logo_in_qr === 'boolean') &&
    (isNullOrUndefined(candidate.can_create_multiple_cards) ||
      typeof candidate.can_create_multiple_cards === 'boolean') &&
    (isNullOrUndefined(candidate.can_display_phone_number) ||
      typeof candidate.can_display_phone_number === 'boolean') &&
    (isNullOrUndefined(candidate.can_remove_blinq_tag) ||
      typeof candidate.can_remove_blinq_tag === 'boolean') &&
    (isNullOrUndefined(candidate.can_remove_card_referral_link) ||
      typeof candidate.can_remove_card_referral_link === 'boolean') &&
    (isNullOrUndefined(candidate.is_premium_subscriber) ||
      typeof candidate.is_premium_subscriber === 'boolean') &&
    (isNullOrUndefined(candidate.is_web_premium_subscriber) ||
      typeof candidate.is_web_premium_subscriber === 'boolean') &&
    (isNullOrUndefined(candidate.is_bb_employee) || typeof candidate.is_bb_employee === 'boolean') &&
    (isNullOrUndefined(candidate.is_blinq_employee) || typeof candidate.is_blinq_employee === 'boolean') &&
    (isNullOrUndefined(candidate.can_book_onboarding) ||
      typeof candidate.can_book_onboarding === 'boolean') &&
    (isNullOrUndefined(candidate.can_export_contacts) || typeof candidate.can_export_contacts === 'boolean')
  );
}
